export default "__VITE_ASSET__C1iRAm60__"